import { CricketGameState } from "./cricket";
import { X01GameState } from "./x01";
import { TEAM } from "./teams";
import { PLAYER } from "./players";
import { GameState } from "./game";

export enum GAME_TYPE {
  NOT_SELECTED,
  CRICKET,
  X01,
  HALVES
}

export enum MATCH_STATE {
  NOT_STARTED,
  ACTIVE,
  FINISHED
}

export enum MATCH_TYPE {
  DOUBLES,
  SINGLES,
  BOT,
  NO_TEAMS
}

export interface MatchSet {
  winner: TEAM | string,
  legs: GameState[],
}

export enum BOT_DIFFICULTY {
  EASY = "Easy",
  MEDIUM = "Medium",
  HARD = "Hard",
  // PRO = "Pro"
}

export interface BotGame {
  playing: boolean;
  difficulty: BOT_DIFFICULTY;
}

export interface BaseMatchState {
  matchState: MATCH_STATE;
  matchType: MATCH_TYPE;
  botDifficulty: BOT_DIFFICULTY;
  // legs per set
  legs: number;
  // sets per match
  sets: number;
  completed: {
    // Array of completed game states in current set
    legs: (GameState)[];
    // Array of legs per set
    sets: MatchSet[]
  }
  gameType: GAME_TYPE;
}

export interface OnlineMatchState {
  id: string;
  players: PLAYER[];
  matchState: BaseMatchState;
  gameType: GAME_TYPE;
  gameState: CricketGameState | X01GameState;
  roomCode: string;
  private: boolean;
  started: boolean;
}